import { useQuery } from "@tanstack/react-query";
import { getModules } from "../../../api/endpoints/LessonEndpoints";

export default function useGetModules() {
  return useQuery({
    queryKey: ["modules"],
    queryFn: getModules,
  });
}
